var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsCarat = function SvgMetricsCarat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 13.443a3.555 3.555 0 0 0-3.551 3.55c0 1.958 1.593 3.551 3.551 3.551s3.551-1.593 3.551-3.551A3.554 3.554 0 0 0 24 13.443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.849 9.151 24 3 9.151 9.151 3 24l6.15 14.849L24 45l14.849-6.15L45 24zM13.525 34.475l2.867-13.917h3.679a5.29 5.29 0 0 1-1.397-3.564A5.33 5.33 0 0 1 24 11.669a5.33 5.33 0 0 1 5.326 5.325 5.28 5.28 0 0 1-1.397 3.564h3.679L34.5 34.475z"
  })))));
};
export default SvgMetricsCarat;